export const PROJECT_LIST_REQUEST = "PROJECT_LIST_REQUEST";
export const PROJECT_LIST_SUCCESS = "PROJECT_LIST_SUCCESS";
export const PROJECT_LIST_FAIL= "PROJECT_LIST_FAIL";
export const PROJECT_LIST_RESET= "PROJECT_LIST_RESET";

export const GET_PROJECT_REQUEST = "GET_PROJECT_REQUEST";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const GET_PROJECT_FAIL= "GET_PROJECT_FAIL";
export const GET_PROJECT_RESET= "GET_PROJECT_RESET";

export const ADD_PROJECT_REQUEST = "ADD_PROJECT_REQUEST";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAIL= "ADD_PROJECT_FAIL";
export const ADD_PROJECT_RESET= "ADD_PROJECT_RESET";

export const RENAME_PROJECT_REQUEST = "RENAME_PROJECT_REQUEST";
export const RENAME_PROJECT_SUCCESS = "RENAME_PROJECT_SUCCESS";
export const RENAME_PROJECT_FAIL= "RENAME_PROJECT_FAIL";
export const RENAME_PROJECT_RESET= "RENAME_PROJECT_RESET";

export const DELETE_PROJECT_REQUEST = "DELETE_PROJECT_REQUEST";
export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
export const DELETE_PROJECT_FAIL= "DELETE_PROJECT_FAIL";
export const DELETE_PROJECT_RESET= "DELETE_PROJECT_RESET";


export const ADD_PROJECT_LINK_REQUEST = "ADD_PROJECT_LINK_REQUEST";
export const ADD_PROJECT_LINK_SUCCESS = "ADD_PROJECT_LINK_SUCCESS";
export const ADD_PROJECT_LINK_FAIL= "ADD_PROJECT_LINK_FAIL";
export const ADD_PROJECT_LINK_RESET= "ADD_PROJECT_LINK_RESET";

export const EDIT_PROJECT_LINK_REQUEST = "EDIT_PROJECT_LINK_REQUEST";
export const EDIT_PROJECT_LINK_SUCCESS = "EDIT_PROJECT_LINK_SUCCESS";
export const EDIT_PROJECT_LINK_FAIL= "EDIT_PROJECT_LINK_FAIL";
export const EDIT_PROJECT_LINK_RESET= "EDIT_PROJECT_LINK_RESET";

export const DELETE_PROJECT_LINK_REQUEST = "DELETE_PROJECT_LINK_REQUEST";
export const DELETE_PROJECT_LINK_SUCCESS = "DELETE_PROJECT_LINK_SUCCESS";
export const DELETE_PROJECT_LINK_FAIL= "DELETE_PROJECT_LINK_FAIL";
export const DELETE_PROJECT_LINK_RESET= "DELETE_PROJECT_LINK_RESET";



export const ADD_PROJECT_TASK_REQUEST = "ADD_PROJECT_TASK_REQUEST";
export const ADD_PROJECT_TASK_SUCCESS = "ADD_PROJECT_TASK_SUCCESS";
export const ADD_PROJECT_TASK_FAIL= "ADD_PROJECT_TASK_FAIL";
export const ADD_PROJECT_TASK_RESET= "ADD_PROJECT_TASK_RESET";

export const EDIT_PROJECT_TASK_REQUEST = "EDIT_PROJECT_TASK_REQUEST";
export const EDIT_PROJECT_TASK_SUCCESS = "EDIT_PROJECT_TASK_SUCCESS";
export const EDIT_PROJECT_TASK_FAIL= "EDIT_PROJECT_TASK_FAIL";
export const EDIT_PROJECT_TASK_RESET= "EDIT_PROJECT_TASK_RESET";

export const DELETE_PROJECT_TASK_REQUEST = "DELETE_PROJECT_TASK_REQUEST";
export const DELETE_PROJECT_TASK_SUCCESS = "DELETE_PROJECT_TASK_SUCCESS";
export const DELETE_PROJECT_TASK_FAIL= "DELETE_PROJECT_TASK_FAIL";
export const DELETE_PROJECT_TASK_RESET= "DELETE_PROJECT_TASK_RESET";

export const CLEAR_PROJECT_DONE_TASKS_REQUEST = "CLEAR_PROJECT_DONE_TASKS_REQUEST";
export const CLEAR_PROJECT_DONE_TASKS_SUCCESS = "CLEAR_PROJECT_DONE_TASKS_SUCCESS";
export const CLEAR_PROJECT_DONE_TASKS_FAIL= "CLEAR_PROJECT_DONE_TASKS_FAIL";
export const CLEAR_PROJECT_DONE_TASKS_RESET= "CLEAR_PROJECT_DONE_TASKS_RESET";

export const ADD_PROJECT_LIST_REQUEST = "ADD_PROJECT_LIST_REQUEST";
export const ADD_PROJECT_LIST_SUCCESS = "ADD_PROJECT_LIST_SUCCESS";
export const ADD_PROJECT_LIST_FAIL= "ADD_PROJECT_LIST_FAIL";
export const ADD_PROJECT_LIST_RESET= "ADD_PROJECT_LIST_RESET";


export const RENAME_PROJECT_LIST_REQUEST = "RENAME_PROJECT_LIST_REQUEST";
export const RENAME_PROJECT_LIST_SUCCESS = "RENAME_PROJECT_LIST_SUCCESS";
export const RENAME_PROJECT_LIST_FAIL= "RENAME_PROJECT_LIST_FAIL";
export const RENAME_PROJECT_LIST_RESET= "RENAME_PROJECT_LIST_RESET";

export const ADD_PROJECT_LIST_ITEM_REQUEST = "ADD_PROJECT_LIST_ITEM_REQUEST";
export const ADD_PROJECT_LIST_ITEM_SUCCESS = "ADD_PROJECT_LIST_ITEM_SUCCESS";
export const ADD_PROJECT_LIST_ITEM_FAIL= "ADD_PROJECT_LIST_ITEM_FAIL";
export const ADD_PROJECT_LIST_ITEM_RESET= "ADD_PROJECT_LIST_ITEM_RESET";

export const TOGGLE_PROJECT_LIST_ITEM_REQUEST = "TOGGLE_PROJECT_LIST_ITEM_REQUEST";
export const TOGGLE_PROJECT_LIST_ITEM_SUCCESS = "TOGGLE_PROJECT_LIST_ITEM_SUCCESS";
export const TOGGLE_PROJECT_LIST_ITEM_FAIL= "TOGGLE_PROJECT_LIST_ITEM_FAIL";
export const TOGGLE_PROJECT_LIST_ITEM_RESET= "TOGGLE_PROJECT_LIST_ITEM_RESET";

export const DELETE_PROJECT_LIST_ITEM_REQUEST = "DELETE_PROJECT_LIST_ITEM_REQUEST";
export const DELETE_PROJECT_LIST_ITEM_SUCCESS = "DELETE_PROJECT_LIST_ITEM_SUCCESS";
export const DELETE_PROJECT_LIST_ITEM_FAIL= "DELETE_PROJECT_LIST_ITEM_FAIL";
export const DELETE_PROJECT_LIST_ITEM_RESET= "DELETE_PROJECT_LIST_ITEM_RESET";

export const DELETE_PROJECT_LIST_REQUEST = "DELETE_PROJECT_LIST_REQUEST";
export const DELETE_PROJECT_LIST_SUCCESS = "DELETE_PROJECT_LIST_SUCCESS";
export const DELETE_PROJECT_LIST_FAIL= "DELETE_PROJECT_LIST_FAIL";
export const DELETE_PROJECT_LIST_RESET= "DELETE_PROJECT_LIST_RESET";


export const SAVE_PROJECT_NOTE_REQUEST = "SAVE_PROJECT_NOTE_REQUEST";
export const SAVE_PROJECT_NOTE_SUCCESS = "SAVE_PROJECT_NOTE_SUCCESS";
export const SAVE_PROJECT_NOTE_FAIL= "SAVE_PROJECT_NOTE_FAIL";
export const SAVE_PROJECT_NOTE_RESET= "SAVE_PROJECT_NOTE_RESET";
